import { FORM_FIELD } from "./widgetTypes";

export const GATING_WIDGETS = [
  {
    "uid": "widget_SjA_gAn",
    "type": "cleverstory.v2.widgets.modal",
    "name": "Modal",
    "capabilities": null,
    "order": 1,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0, 0",
            "rotate": "0deg"
          },
          "width": "1200px",
          "height": "600px"
        },
        "border": null,
        "background": {
          "color": {
            "r": 101,
            "g": 101,
            "b": 101,
            "a": 1
          },
          "type": "color"
        },
        "formEmailTemplate": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0, 0",
            "rotate": "0deg"
          },
          "width": "375px",
          "height": "628px"
        },
        "border": null,
        "background": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_e-_yoyOaWB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "capabilities": null,
    "parent": "widget_SjA_gAn",
    "order": 3,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "64.0066842px,291.5px",
            "rotate": "0.015508127910573488deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "19",
        "lineSpacing": "1.3",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20.5px,83.3134155px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "335px",
          "height": "auto"
        },
        "fontSize": "13",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<p style=\"font-size: 19px;\"><span style=\"font-size: 19px; font-family: Montserrat, sans-serif; font-weight: 400; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">We promise it'll be worth it - quickly fill </span></p>\n<p style=\"font-size: 19px;\"><span style=\"font-size: 19px; font-family: Montserrat, sans-serif; font-weight: 400; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">up this form to continue reading further</span></p>"
  },
  {
    "uid": "widget_VoPxQSfrXq",
    "type": "cleverstory.v2.widgets.image",
    "name": "Image",
    "capabilities": null,
    "parent": "widget_fbLHLERVYx",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "198.0000000000001px,48.99999999999969px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "317px",
          "height": "274.961px"
        },
        "crop": null,
        "alt": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px,20px",
            "rotate": "0deg"
          },
          "width": "295px",
          "height": "256.0584635416667px"
        },
        "crop": null,
        "alt": null,
        "animation": null
      }
    }
  },
  {
    "uid": "widget_gPjJZu_A5m",
    "type": FORM_FIELD,
    "name": "Last Name",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "310px,96px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "255px",
          "height": "auto"
        },
        "field": "lastname",
        "label": "Last Name",
        "placeholder": "Enter last name",
        "workEmail": false,
        "mandatory": false,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,159.50037499999996px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_zTRH284LDk",
    "type": "cleverstory.v2.widgets.form.submit",
    "name": "Submit Button",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 6,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,345px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "200px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": null,
            "width": "0",
            "radius": {
              "lock": true,
              "topLeft": "20",
              "topRight": "20",
              "bottomLeft": "20",
              "bottomRight": "20"
            }
          }
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": null
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,402.4998134765624px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "200px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": null,
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": null,
          "border": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": null,
          "border": null
        },
        "alignment": null,
        "animation": null
      }
    },
    "content": "Submit"
  },
  {
    "uid": "widget_OCf44NM--",
    "type": "cleverstory.v2.widgets.form",
    "name": "Form",
    "capabilities": null,
    "parent": "widget_SjA_gAn",
    "order": 1,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "530px,105.5px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "600px",
          "height": "415px"
        },
        "border": null,
        "background": {
          "r": 245,
          "g": 245,
          "b": 245,
          "a": 1
        },
        "formEmailTemplate": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20.5px,137px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "335px",
          "height": "463px"
        },
        "border": null,
        "background": null,
        "formEmailTemplate": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_kzcYxdYKCB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 1,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,30px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px,20px",
            "rotate": "0deg"
          },
          "width": "233.875px",
          "height": "auto"
        },
        "fontSize": "32",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<h3>Get in touch</h3>"
  },
  {
    "uid": "widget_ZgD5VUK9iG",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_fbLHLERVYx",
    "order": 2,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px, 360px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px, 415px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "238.4921875px",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<p>We&rsquo;ll get back to you shortly :)</p>"
  },
  {
    "uid": "widget_FIHh_5AFTy",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_fbLHLERVYx",
    "order": 1,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,268px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "353.461px",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px,336.00048828125px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "261px",
          "height": "auto"
        },
        "fontSize": "32",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<h3><strong>Thanks </strong></h3>\n<h3><strong>for submitting!</strong></h3>"
  },
  {
    "uid": "widget_SHaWDk4ASH",
    "type": "cleverstory.v2.widgets.form.step",
    "name": "Form",
    "capabilities": null,
    "parent": "widget_OCf44NM--",
    "order": 1,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      }
    },
    "content": null
  },
  {
    "uid": "widget_wtiJnQxEYk",
    "type": FORM_FIELD,
    "name": "Email",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 4,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,179px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "540px",
          "height": "auto"
        },
        "field": "email",
        "label": "Email",
        "placeholder": "Enter email address",
        "workEmail": true,
        "mandatory": true,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,240.51673242187496px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_Mjkb3a4uD",
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "capabilities": null,
    "parent": "widget_SjA_gAn",
    "order": 2,
    "fonts": [
      "62315f0b71084f6997da73c6"
    ],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "64px,147.5px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "40",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px, 20px",
            "rotate": "0deg"
          },
          "width": "335px",
          "height": "auto"
        },
        "fontSize": "19",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<h1 style=\"font-size: 40px;\"><span style=\"font-size: 40px; font-family: cs_font_62223e921c871f6f56fe226f; font-weight: 500; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">A pitstop before this </span></h1>\n<h1 style=\"font-size: 40px;\"><span style=\"font-size: 40px; font-family: cs_font_62223e921c871f6f56fe226f; font-weight: 500; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">gets reallllly good.</span></h1>"
  },
  {
    "uid": "widget_fbLHLERVYx",
    "type": "cleverstory.v2.widgets.form.step",
    "name": "Success",
    "capabilities": null,
    "parent": "widget_OCf44NM--",
    "order": 2,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      }
    },
    "content": null
  },
  {
    "uid": "widget_hOz7gfiAVb",
    "type": FORM_FIELD,
    "name": "Company",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 5,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,262px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "540px",
          "height": "auto"
        },
        "field": "company",
        "label": "Company",
        "placeholder": "Enter company",
        "workEmail": false,
        "mandatory": false,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "18.5px,321.5328134765624px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_DFixwqlpA4",
    "type": FORM_FIELD,
    "name": "First Name",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 2,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,96px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "255px",
          "height": "auto"
        },
        "field": "firstname",
        "label": "First Name",
        "placeholder": "Enter first name",
        "workEmail": false,
        "mandatory": false,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,78.484375px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_SHbWDk4BSH",
    "type": "cleverstory.v2.widgets.form.step",
    "name": "OTP",
    "capabilities": null,
    "parent": "widget_OCf44NM--",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      }
    },
    "content": null
  },
  {
    "uid": "widget_kzdYxdYKDB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 1,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "141.33px,40px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": null,
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30.275px,50px",
            "rotate": "0deg"
          },
          "width": "274.45px",
          "height": "auto"
        },
        "fontSize": "32",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": null,
        "alignment": "left",
        "animation": null
      }
    },
    "content": '<h3>Please enter OTP</h3>'
  },
  {
    "uid": "widget_kzdYxdYKEB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 2,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "84.06px, 125px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "27.5px, 135px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "280px",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null
      }
    },
    "content": '<p style="font-size: 12px;" >A One-Time Passcode has been sent to your email as a verification code.</p>'
  },
  {
    "uid": "widget_kzdYxdYKFB",
    "type": "cleverstory.v2.widgets.otp.input",
    "name": "OTP",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "184px,180px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "field": "otp",
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": true,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "8",
            "width":"50",
            "height":"50",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "55.5px,215px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "field": "otp",
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": true,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "8",
            "width":"50",
            "height":"50",
            "regular": null
          }
        }
      }
    }
  },
  {
    "uid": "widget_kzdYxdYKGB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 4,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "192.595px,250px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "60.055px, 285px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "214.89px",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null
      }
    },
    "content": '<p style="font-size: 12px;" >This code will be valid for 2 minutes.</p>'
  },
  {
    "uid": "widget_kzdYxdYKHB",
    "type": "cleverstory.v2.widgets.otp.submit",
    "name": "OTP Submit Button",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 5,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "235px,290px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "130px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": null,
            "width": "0",
            "radius": {
              "lock": true,
              "topLeft": "20",
              "topRight": "20",
              "bottomLeft": "20",
              "bottomRight": "20"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "102.5px,325px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "130px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": null,
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: "Submit"
  },
  {
    "uid": "widget_kzdYxdYKIB",
    "type": "cleverstory.v2.widgets.otp.resend",
    "name": "OTP Resend Button",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 6,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "206.74px,360px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "181.21px",
          "height": "20px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "13",
            "fontWeight": "550",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 0,
            "g": 0,
            "b": 0,
            "a": 0
          },
          "border": {
            "sides": null,
            "color": null,
            "width": "0",
            "radius": {
              "lock": true,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 0,
            "g": 0,
            "b": 0,
            "a": 0
          },
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "76.895px, 395px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "181.21px",
          "height": "20px"
        },
        "regular": {
          "font": {
            "style": null,
            "fontSize": "13",
            "fontWeight": "550",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    "content": "Resend code to your email"
  }
]


export const SPATIAL_GATING_WIDGETS = [
  {
    "uid": "widget_SjA_gAn",
    "type": "cleverstory.v2.widgets.slide",
    "name": "Modal",
    "capabilities": null,
    "order": 1,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0, 0",
            "rotate": "0deg"
          },
          "width": "1200px",
          "height": "666.75px"
        },
        "border": null,
        "background": {
          "color": {
            "r": 101,
            "g": 101,
            "b": 101,
            "a": 1
          },
          "type": "color"
        },
        "formEmailTemplate": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0, 0",
            "rotate": "0deg"
          },
          "width": "375px",
          "height": "666.75px"
        },
        "border": null,
        "background": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_e-_yoyOaWB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "capabilities": null,
    "parent": "widget_SjA_gAn",
    "order": 3,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "64.0066842px,291.5px",
            "rotate": "0.015508127910573488deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "19",
        "lineSpacing": "1.3",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20.5px,83.3134155px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "335px",
          "height": "auto"
        },
        "fontSize": "13",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<p style=\"font-size: 19px;\"><span style=\"font-size: 19px; font-family: Montserrat, sans-serif; font-weight: 400; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">We promise it'll be worth it - quickly fill </span></p>\n<p style=\"font-size: 19px;\"><span style=\"font-size: 19px; font-family: Montserrat, sans-serif; font-weight: 400; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">up this form to continue reading further</span></p>"
  },
  {
    "uid": "widget_VoPxQSfrXq",
    "type": "cleverstory.v2.widgets.image",
    "name": "Image",
    "capabilities": null,
    "parent": "widget_fbLHLERVYx",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "198.0000000000001px,48.99999999999969px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "317px",
          "height": "274.961px"
        },
        "crop": null,
        "alt": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px,20px",
            "rotate": "0deg"
          },
          "width": "295px",
          "height": "256.0584635416667px"
        },
        "crop": null,
        "alt": null,
        "animation": null
      }
    }
  },
  {
    "uid": "widget_gPjJZu_A5m",
    "type": FORM_FIELD,
    "name": "Last Name",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "310px,96px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "255px",
          "height": "auto"
        },
        "field": "lastname",
        "label": "Last Name",
        "placeholder": "Enter last name",
        "workEmail": false,
        "mandatory": false,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,159.50037499999996px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_zTRH284LDk",
    "type": "cleverstory.v2.widgets.form.submit",
    "name": "Submit Button",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 6,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,345px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "200px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": null,
            "width": "0",
            "radius": {
              "lock": true,
              "topLeft": "20",
              "topRight": "20",
              "bottomLeft": "20",
              "bottomRight": "20"
            }
          }
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": null
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,402.4998134765624px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "200px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": null,
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": null,
          "border": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": null,
          "border": null
        },
        "alignment": null,
        "animation": null
      }
    },
    "content": "Submit"
  },
  {
    "uid": "widget_OCf44NM--",
    "type": "cleverstory.v2.widgets.form",
    "name": "Form",
    "capabilities": null,
    "parent": "widget_SjA_gAn",
    "order": 1,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "530px,105.5px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "600px",
          "height": "415px"
        },
        "border": null,
        "background": {
          "r": 245,
          "g": 245,
          "b": 245,
          "a": 1
        },
        "formEmailTemplate": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20.5px,137px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "335px",
          "height": "463px"
        },
        "border": null,
        "background": null,
        "formEmailTemplate": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_kzcYxdYKCB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 1,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,30px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px,20px",
            "rotate": "0deg"
          },
          "width": "233.875px",
          "height": "auto"
        },
        "fontSize": "32",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<h3>Get in touch</h3>"
  },
  {
    "uid": "widget_ZgD5VUK9iG",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_fbLHLERVYx",
    "order": 2,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px, 360px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px, 415px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "238.4921875px",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<p>We&rsquo;ll get back to you shortly :)</p>"
  },
  {
    "uid": "widget_FIHh_5AFTy",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_fbLHLERVYx",
    "order": 1,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,268px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "353.461px",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px,336.00048828125px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "261px",
          "height": "auto"
        },
        "fontSize": "32",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 0,
          "g": 0,
          "b": 0,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<h3><strong>Thanks </strong></h3>\n<h3><strong>for submitting!</strong></h3>"
  },
  {
    "uid": "widget_SHaWDk4ASH",
    "type": "cleverstory.v2.widgets.form.step",
    "name": "Form",
    "capabilities": null,
    "parent": "widget_OCf44NM--",
    "order": 1,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      }
    },
    "content": null
  },
  {
    "uid": "widget_wtiJnQxEYk",
    "type": FORM_FIELD,
    "name": "Email",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 4,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,179px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "540px",
          "height": "auto"
        },
        "field": "email",
        "label": "Email",
        "placeholder": "Enter email address",
        "workEmail": true,
        "mandatory": true,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,240.51673242187496px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_Mjkb3a4uD",
    "type": "cleverstory.v2.widgets.text",
    "name": "Text",
    "capabilities": null,
    "parent": "widget_SjA_gAn",
    "order": 2,
    "fonts": [
      "62315f0b71084f6997da73c6"
    ],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "64px,147.5px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "40",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "20px, 20px",
            "rotate": "0deg"
          },
          "width": "335px",
          "height": "auto"
        },
        "fontSize": "19",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": {
          "r": 255,
          "g": 255,
          "b": 255,
          "a": 1
        },
        "alignment": "left",
        "animation": null
      }
    },
    "content": "<h1 style=\"font-size: 40px;\"><span style=\"font-size: 40px; font-family: cs_font_62223e921c871f6f56fe226f; font-weight: 500; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">A pitstop before this </span></h1>\n<h1 style=\"font-size: 40px;\"><span style=\"font-size: 40px; font-family: cs_font_62223e921c871f6f56fe226f; font-weight: 500; color: rgb(255, 255, 255); background-color: rgba(0, 0, 0, 0); font-style: normal; text-decoration: none solid rgb(0, 0, 0);\">gets reallllly good.</span></h1>"
  },
  {
    "uid": "widget_fbLHLERVYx",
    "type": "cleverstory.v2.widgets.form.step",
    "name": "Success",
    "capabilities": null,
    "parent": "widget_OCf44NM--",
    "order": 2,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      }
    },
    "content": null
  },
  {
    "uid": "widget_hOz7gfiAVb",
    "type": FORM_FIELD,
    "name": "Company",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 5,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,262px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "540px",
          "height": "auto"
        },
        "field": "company",
        "label": "Company",
        "placeholder": "Enter company",
        "workEmail": false,
        "mandatory": false,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "18.5px,321.5328134765624px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_DFixwqlpA4",
    "type": FORM_FIELD,
    "name": "First Name",
    "capabilities": null,
    "parent": "widget_SHaWDk4ASH",
    "order": 2,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30px,96px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "255px",
          "height": "auto"
        },
        "field": "firstname",
        "label": "First Name",
        "placeholder": "Enter first name",
        "workEmail": false,
        "mandatory": false,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "2",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "19px,78.484375px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "295px",
          "height": "auto"
        },
        "field": null,
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": false,
        "styles": null
      }
    },
    "content": null
  },
  {
    "uid": "widget_SHbWDk4BSH",
    "type": "cleverstory.v2.widgets.form.step",
    "name": "OTP",
    "capabilities": null,
    "parent": "widget_OCf44NM--",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": null,
          "height": null
        }
      }
    },
    "content": null
  },
  {
    "uid": "widget_kzdYxdYKDB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 1,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "141.33px,40px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "16",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": null,
        "alignment": "left",
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "30.275px,50px",
            "rotate": "0deg"
          },
          "width": "274.45px",
          "height": "auto"
        },
        "fontSize": "32",
        "lineSpacing": "1.2",
        "letterSpacing": "0",
        "color": null,
        "alignment": "left",
        "animation": null
      }
    },
    "content": '<h3>Please enter OTP</h3>'
  },
  {
    "uid": "widget_kzdYxdYKEB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 2,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "84.06px, 125px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "27.5px, 135px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "280px",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null
      }
    },
    "content": '<p style="font-size: 12px;" >A One-Time Passcode has been sent to your email as a verification code.</p>'
  },
  {
    "uid": "widget_kzdYxdYKFB",
    "type": "cleverstory.v2.widgets.otp.input",
    "name": "OTP",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 3,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "184px,180px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "field": "otp",
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": true,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "8",
            "width":"50",
            "height":"50",
            "regular": null
          },
          "regular": {
            "border": {
              "sides": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "width": "2",
              "radius": null,
              "style": "bottom"
            },
            "label": {
              "background": null,
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": null,
              "font": {
                "style": null,
                "fontSize": "12",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            },
            "input": {
              "background": {
                "type": "solid",
                "r": 255,
                "g": 255,
                "b": 255,
                "a": 1
              },
              "color": {
                "type": "solid",
                "r": 0,
                "g": 0,
                "b": 0,
                "a": 1
              },
              "placeholderColor": {
                "type": "solid",
                "r": 213,
                "g": 213,
                "b": 213,
                "a": 1
              },
              "font": {
                "style": null,
                "fontSize": "14",
                "fontFamily": "Montserrat,sans-serif",
                "lineSpacing": null,
                "letterSpacing": null,
                "color": null
              }
            }
          }
        }
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "55.5px,215px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "field": "otp",
        "label": null,
        "placeholder": null,
        "workEmail": false,
        "mandatory": true,
        "styles": {
          "layout": {
            "alignment": "left",
            "labelPadding": "0",
            "inputPadding": "12",
            "fieldSpacing": "8",
            "width":"50",
            "height":"50",
            "regular": null
          }
        }
      }
    }
  },
  {
    "uid": "widget_kzdYxdYKGB",
    "type": "cleverstory.v2.widgets.text",
    "name": "Form Title",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 4,
    "fonts": [],
    "actions": [],
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "192.595px,250px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "auto",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "60.055px, 285px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "214.89px",
          "height": "auto"
        },
        "fontSize": "12",
        "fontFamily": null,
        "lineSpacing": null,
        "letterSpacing": null,
        "color": null
      }
    },
    "content": '<p style="font-size: 12px;" >This code will be valid for 2 minutes.</p>'
  },
  {
    "uid": "widget_kzdYxdYKHB",
    "type": "cleverstory.v2.widgets.otp.submit",
    "name": "OTP Submit Button",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 5,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "235px,290px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "130px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": false,
              "italic": false,
              "underline": false
            },
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": {
            "sides": null,
            "color": null,
            "width": "0",
            "radius": {
              "lock": true,
              "topLeft": "20",
              "topRight": "20",
              "bottomLeft": "20",
              "bottomRight": "20"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 255,
            "g": 198,
            "b": 0,
            "a": 1
          },
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "102.5px,325px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "130px",
          "height": "40px"
        },
        "regular": {
          "font": {
            "style": null,
            "fontSize": "14",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    content: "Submit"
  },
  {
    "uid": "widget_kzdYxdYKIB",
    "type": "cleverstory.v2.widgets.otp.resend",
    "name": "OTP Resend Button",
    "capabilities": null,
    "parent": "widget_SHbWDk4BSH",
    "order": 6,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "206.74px,360px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "181.21px",
          "height": "20px"
        },
        "regular": {
          "font": {
            "style": {
              "bold": true,
              "italic": false,
              "underline": false
            },
            "fontSize": "13",
            "fontWeight": "550",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 0,
            "g": 0,
            "b": 0,
            "a": 0
          },
          "border": {
            "sides": null,
            "color": null,
            "width": "0",
            "radius": {
              "lock": true,
              "topLeft": "0",
              "topRight": "0",
              "bottomLeft": "0",
              "bottomRight": "0"
            }
          },
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": {
              "type": "solid",
              "r": 0,
              "g": 0,
              "b": 0,
              "a": 1
            }
          },
          "background": {
            "type": "solid",
            "r": 0,
            "g": 0,
            "b": 0,
            "a": 0
          },
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "76.895px, 395px",
            "rotate": "0deg",
            "scale": "1,1"
          },
          "width": "181.21px",
          "height": "20px"
        },
        "regular": {
          "font": {
            "style": null,
            "fontSize": "13",
            "fontWeight": "550",
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "hover": {
          "font": {
            "style": null,
            "fontSize": null,
            "fontFamily": null,
            "lineSpacing": null,
            "letterSpacing": null,
            "color": null
          },
          "background": null,
          "border": null,
          "shadow": null
        },
        "alignment": null,
        "animation": null
      }
    },
    "content": "Resend code to your email"
  }
]